// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2ZasX","footer":"ModalCreateQualiphyProcedure_footer__1LnQ8","additionData":"ModalCreateQualiphyProcedure_additionData__33Rme"};